/* Newport Run Club theme JS */
document.addEventListener("DOMContentLoaded", function(){

  /* marquee seamless loop */
  document.querySelectorAll("[data-marquee]").forEach(function(mq){
    mq.innerHTML += mq.innerHTML;
  });

  /* ---------- lead capture ---------- */
  var veil = document.getElementById("nrc-veil");
  if(veil){
    var KEY = "nrcLeadSeen";
    var DAYS = parseInt(veil.dataset.frequency || "30", 10);
    var DELAY = parseInt(veil.dataset.delay || "8", 10) * 1000;
    var opened = false;

    function seen(){
      try{
        var raw = localStorage.getItem(KEY);
        if(!raw) return false;
        return (Date.now() - parseInt(raw,10)) < DAYS*86400000;
      }catch(e){ return false; }
    }
    function markSeen(){
      try{ localStorage.setItem(KEY, String(Date.now())); }catch(e){}
    }
    function openLead(preselect){
      veil.classList.add("open");
      opened = true;
      if(preselect) selectPath(preselect);
    }
    function closeLead(){
      veil.classList.remove("open");
      markSeen();
    }
    function selectPath(p){
      veil.querySelectorAll(".path").forEach(function(x){ x.classList.toggle("on", x.dataset.p===p); });
      veil.querySelectorAll(".fields").forEach(function(x){ x.classList.remove("show"); });
      var f = document.getElementById("f-"+p);
      if(f) f.classList.add("show");
    }
    window.nrcOpenLead = openLead;

    veil.addEventListener("click", function(e){
      if(e.target===veil) closeLead();
      var b = e.target.closest(".path");
      if(b) selectPath(b.dataset.p);
      if(e.target.closest("[data-lead-close]")) closeLead();
    });
    document.addEventListener("keydown", function(e){ if(e.key==="Escape") closeLead(); });

    /* if a form just posted, show modal with success + mark converted */
    var params = new URLSearchParams(location.search);
    if(params.get("customer_posted")==="true" || (location.hash==="#nrc-partner-form" && params.get("contact_posted")==="true")){
      markSeen();
    }

    function maybeOpen(){ if(!seen() && !opened) openLead(null); }
    if(!seen()){
      setTimeout(maybeOpen, DELAY);
      window.addEventListener("scroll", function(){
        var pct = (window.scrollY + window.innerHeight) / document.body.scrollHeight;
        if(pct > .4) maybeOpen();
      }, {passive:true});
    }

    /* any element with data-open-lead opens it, optionally preselecting a path */
    document.querySelectorAll("[data-open-lead]").forEach(function(el){
      el.addEventListener("click", function(e){
        e.preventDefault();
        openLead(el.dataset.openLead || null);
      });
    });
  }

  /* ---------- mobile nav ---------- */
  var navToggle = document.querySelector(".nav-toggle");
  var navLeft = document.getElementById("nav-left");
  if(navToggle && navLeft){
    navToggle.addEventListener("click", function(){
      var open = navLeft.classList.toggle("open");
      navToggle.setAttribute("aria-expanded", open ? "true" : "false");
    });
  }

  /* ---------- events page ---------- */
  var evBox = document.getElementById("nrc-events");
  if(evBox){
    var MONTHS = ["January","February","March","April","May","June","July","August","September","October","November","December"];
    var DAYS_N = ["Sun","Mon","Tue","Wed","Thu","Fri","Sat"];

    function readJSON(id){
      var el = document.getElementById(id);
      if(!el) return [];
      try{ return JSON.parse(el.textContent) || []; }catch(e){ return []; }
    }

    var events   = readJSON("nrc-events-data");
    var standing = readJSON("nrc-standing-data");
    var autoWeeks = parseInt(evBox.dataset.autoWeeks || "8", 10);

    function iso(d){
      return d.getFullYear() + "-" + String(d.getMonth()+1).padStart(2,"0") + "-" + String(d.getDate()).padStart(2,"0");
    }
    function midnight(d){ var x = new Date(d); x.setHours(0,0,0,0); return x; }
    function parseISO(str){
      if(!str) return null;
      var m = /^(\d{4})-(\d{2})-(\d{2})$/.exec(String(str).trim());
      if(!m) return null;
      var d = new Date(+m[1], +m[2]-1, +m[3]);
      return isNaN(d) ? null : midnight(d);
    }

    /* next occurrence of weekday on/after `from`, honouring an every-other-week anchor */
    function nextOccurrence(from, day, cadence, anchorStr){
      var d = midnight(from);
      while(d.getDay() !== day) d.setDate(d.getDate()+1);
      if(cadence !== "biweekly") return d;
      var anchor = parseISO(anchorStr);
      if(!anchor) return d;
      while(anchor.getDay() !== day) anchor.setDate(anchor.getDate()+1);
      var weeks = Math.round((d - anchor) / 604800000);
      if(((weeks % 2) + 2) % 2 !== 0) d.setDate(d.getDate()+7);
      return d;
    }

    /* expand standing runs forward */
    standing.forEach(function(r){
      if(autoWeeks <= 0) return;
      var day = parseInt(r.day, 10);
      if(isNaN(day)) return;
      var step = (r.cadence === "biweekly") ? 14 : 7;
      var d = nextOccurrence(new Date(), day, r.cadence, r.anchor);
      var horizon = midnight(new Date());
      horizon.setDate(horizon.getDate() + autoWeeks*7);
      while(d <= horizon){
        events.push({
          date: iso(d), time: r.time || "", name: r.name || "", partner: "",
          type: "run", loc: r.loc || "", cta_label: r.cta_label || "Just show up", cta_url: ""
        });
        d = new Date(d); d.setDate(d.getDate() + step);
      }
    });

    function fmt(isoStr){
      var dd = new Date(isoStr+"T12:00:00");
      return { day:DAYS_N[dd.getDay()], num:String(dd.getDate()).padStart(2,"0"), month:MONTHS[dd.getMonth()], year:dd.getFullYear() };
    }
    function esc(v){
      return String(v==null?"":v).replace(/[&<>"']/g, function(c){
        return {"&":"&amp;","<":"&lt;",">":"&gt;",'"':"&quot;","'":"&#39;"}[c];
      });
    }

    function render(filter){
      var today = midnight(new Date());
      var list = events.filter(function(e){ return e.date && new Date(e.date+"T23:59:00") >= today; })
        .filter(function(e){ return filter==="all" || e.type===filter; })
        .sort(function(a,b){ return a.date.localeCompare(b.date) || String(a.time).localeCompare(String(b.time)); });

      if(!list.length){ evBox.innerHTML = "<p class=\"empty\">Nothing on the calendar in this category yet — the newsletter hears first.</p>"; return; }

      var html = "", lastKey = "";
      list.forEach(function(e){
        var f = fmt(e.date);
        var key = f.month + " " + f.year;
        if(key !== lastKey){
          if(lastKey) html += "</div>";
          html += "<div class=\"month\"><div class=\"month-label\">"+esc(key)+"</div>";
          lastKey = key;
        }
        var cta = e.cta_url
          ? "<a class=\"u\" href=\""+esc(e.cta_url)+"\">"+esc(e.cta_label||"Details")+"</a>"
          : "<span class=\"grey\">"+esc(e.cta_label||"")+"</span>";
        html += "<div class=\"evt is-"+esc(e.type)+"\">"
          + "<span class=\"date\">"+esc(f.day)+" "+esc(f.num)+"</span>"
          + "<span class=\"name\">"+esc(e.name)+(e.partner?"<span class=\"partner\">"+esc(e.partner)+"</span>":"")+"</span>"
          + "<span class=\"loc\">"+esc(e.loc||"")+"</span>"
          + "<span class=\"time\">"+esc(e.time||"")+"</span>"
          + "<span class=\"cta\">"+cta+"</span>"
          + "</div>";
      });
      html += "</div>";
      evBox.innerHTML = html;
    }
    render("all");

    var filters = document.getElementById("nrc-filters");
    if(filters){
      filters.addEventListener("click", function(ev){
        var b = ev.target.closest("button"); if(!b) return;
        filters.querySelectorAll("button").forEach(function(x){ x.classList.remove("on"); });
        b.classList.add("on");
        render(b.dataset.f);
      });
    }

    /* per-run "next:" stamp */
    document.querySelectorAll(".next-run").forEach(function(el){
      var day = parseInt(el.dataset.nextDay, 10);
      if(isNaN(day)) return;
      var d = nextOccurrence(new Date(), day, el.dataset.nextCadence, el.dataset.nextAnchor);
      var t = (el.dataset.nextTime || "").toLowerCase();
      el.textContent = "next: " + DAYS_N[day].toLowerCase() + " "
        + String(d.getMonth()+1).padStart(2,"0") + "/" + String(d.getDate()).padStart(2,"0")
        + (t ? " · " + t : "");
    });
  }

  /* ---------- product page variant handling ---------- */
  var pform = document.querySelector("[data-product-form]");
  if(pform){
    var variants = [];
    try{ variants = JSON.parse(pform.querySelector("[data-variants]").textContent); }catch(e){}
    var selects = pform.querySelectorAll("[data-option-select]");
    var idInput = pform.querySelector("[name=id]");
    var buyBtn = pform.querySelector("[data-buy]");
    var priceEl = document.querySelector("[data-price]");

    function currentVariant(){
      var opts = Array.prototype.map.call(selects, function(s){ return s.value; });
      return variants.find(function(v){
        return opts.every(function(o,i){ return v.options[i]===o; });
      });
    }
    function money(cents){ return "$" + (cents/100).toFixed(2).replace(/\.00$/,""); }
    function update(){
      var v = currentVariant();
      if(v){
        idInput.value = v.id;
        if(priceEl) priceEl.textContent = money(v.price);
        if(v.available){ buyBtn.disabled = false; buyBtn.textContent = buyBtn.dataset.label || "Add to cart"; }
        else { buyBtn.disabled = true; buyBtn.textContent = "Sold out"; }
      } else {
        buyBtn.disabled = true; buyBtn.textContent = "Unavailable";
      }
    }
    selects.forEach(function(s){ s.addEventListener("change", update); });
    if(selects.length) update();

    /* thumbnail switching */
    var main = document.querySelector("[data-main-image]");
    document.querySelectorAll("[data-thumb]").forEach(function(t){
      t.addEventListener("click", function(){
        if(main) main.src = t.dataset.thumb;
        document.querySelectorAll("[data-thumb]").forEach(function(x){ x.classList.remove("on"); });
        t.classList.add("on");
      });
    });
  }
});
